export class StripeCreateSessionResponse {
    PublicKey: string;
    Token: string;
    QuoteToken: string;
    StripeToken?: string;
    ClientSecret: string;
    customer: Customer;
    pcipay: PCIPay;
    Color: any;
}
export class PCIPay {
    ReturnURL: string;
}

export class Customer {
    CustomerID: number;
    UserID: string;
    Password: string;
    Prefix: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Suffix: string;
    Address1: string;
    Address2: string;
    City: string;
    State: string;
    PostalCode: string;
    PhoneNumber: string;
    EmailAddress: string;
    AccountType : number;
    CorpName: string;
    OwnerType: number;
    OwnerID: number;
    SetupOnTR: boolean;
    Misc: string;
    Priviledges: number;
    Address2_1: string;
    Address2_2: string;
    City2: string;
    State2: string;
    PostalCode2: string;
    Address3_1: string;
    Address3_2: string;
    City3: string;
    State3: string;
    PostalCode3: string;
    OldCustomerID: number;
    PhoneNumber2: string;
    PhoneNumber3: string;
    Phone2Desc: string;
    Phone3Desc: string;
    MobileNumber: string;
    SalesRep: string;
    UserDefinedNumeric1: number;
    UserDefinedNumeric2: number;
    UserDefinedNumeric3: number;
    UserDefinedNumeric4: number;
    UserDefinedNumeric5: number;
    UserDefinedNumeric6: number;
    UserDefinedNumeric7: number;
    UserDefinedNumeric8: number;
    UserDefinedNumeric9: number;
    UserDefinedNumeric10: number;
    UserDefinedAmt1: number;
    UserDefinedAmt2: number;
    UserDefinedAmt3: number;
    UserDefinedAmt4: number;
    UserDefinedAmt5: number;
    UserDefinedAmt6: number;
    UserDefinedAmt7: number;
    UserDefinedAmt8: number;
    UserDefinedAmt9: number;
    UserDefinedAmt10: number;
    UserDefinedDate1: string;
    UserDefinedDate2: string;
    UserDefinedDate3: string;
    UserDefinedDate4: string;
    UserDefinedDate5: string;
    UserDefinedDate6: string;
    UserDefinedDate7: string;
    UserDefinedDate8: string;
    UserDefinedDate9: string;
    UserDefinedDate10: string;
    UserDefinedText1: string;
    UserDefinedText2: string;
    UserDefinedText3: string;
    UserDefinedText4: string;
    UserDefinedText5: string;
    UserDefinedText6: string;
    UserDefinedText7: string;
    UserDefinedText8: string;
    UserDefinedText9: string;
    UserDefinedText10: string;
    StateOther: string;
    SalesRepID: string;
    Country: string;
    FacebookID: string;
    AccountCreatedFlag: boolean;
    PinQuestion: string;
    PinAnswer: string;
    ValidEmailFlag: boolean;
    LoginToken: string;
    GroupPortalFlag: boolean;
    StripeCustomerID: string;
    UpdateFlag: boolean;
    UpdateText: string;
    forcePasswordUpdate: boolean;
}



// WEBPACK FOOTER //
// ./src/services/stripe/stripe.model.ts